import apiClient from '../apiClient';

export const getCustomers = (params = {}) => {
  const queryParams = new URLSearchParams({
    pageNumber: params.pageNumber || 1,
    pageSize: params.pageSize || 50,
    searchTerm: params.searchTerm || '',
    sortBy: params.sortBy || 'customerName',
    sortDescending: params.sortDescending || false
  }).toString();

  return apiClient.get(`/customers?${queryParams}`);
};

export const getCustomersForDropdown = () => {
  return apiClient.get('/customers/list');
};

export const getCustomer = (id) => {
  return apiClient.get(`/customers/${id}`);
};

export const createCustomer = (customerData) => {
  return apiClient.post('/customers', customerData);
};

export const updateCustomer = (id, customerData) => {
  return apiClient.put(`/customers/${id}`, customerData);
};

export const deleteCustomer = (id) => {
  return apiClient.delete(`/customers/${id}`);
};

export const restoreCustomer = (id) => apiClient.post(`/customers/${id}/restore`);

export const getAllCustomersIncludingInactive = (params) => apiClient.get(`/customers/all`, { params });